import { render, staticRenderFns } from "./TietueenPerustiedotCard.vue?vue&type=template&id=4280ddc7&"
import script from "./TietueenPerustiedotCard.vue?vue&type=script&lang=js&"
export * from "./TietueenPerustiedotCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4280ddc7')) {
      api.createRecord('4280ddc7', component.options)
    } else {
      api.reload('4280ddc7', component.options)
    }
    module.hot.accept("./TietueenPerustiedotCard.vue?vue&type=template&id=4280ddc7&", function () {
      api.rerender('4280ddc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TietueenPerustiedotCard.vue"
export default component.exports